import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check, ChevronDown } from "lucide-react";
import { LANGUAGES } from "../i18n";

export const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="language-switcher-trigger"
        className={`inline-flex items-center gap-1.5 rounded-full border border-white/10 hover:border-white/25 text-zinc-300 hover:text-white transition-colors ${
          compact ? "px-2.5 py-1.5 text-xs" : "px-3 py-1.5 text-sm"
        }`}
      >
        <Globe className="w-3.5 h-3.5" strokeWidth={2} />
        <span className="font-mono text-[11px] tracking-wider">{current.flag}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} strokeWidth={2} />
      </button>
      {open && (
        <div
          data-testid="language-switcher-menu"
          className="absolute right-0 top-full mt-2 min-w-[160px] rounded-xl border border-white/10 bg-[#0a0a0a] backdrop-blur shadow-2xl overflow-hidden z-50"
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-2.5 px-3 py-2 text-left text-sm hover:bg-white/[0.04] transition-colors ${
                l.code === current.code ? "text-white" : "text-zinc-300"
              }`}
            >
              <span className="font-mono text-[10px] tracking-wider text-zinc-500 w-6">
                {l.flag}
              </span>
              <span className="flex-1">{l.name}</span>
              {l.code === current.code && (
                <Check className="w-3.5 h-3.5" style={{ color: "#39FF14" }} strokeWidth={2.5} />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
